import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgHomeNavIcon(props) {
  return jsx("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "m10 2.71 7.75 7.35v7.7H2.25V9.79L10 2.71ZM10.01 1 1 9.24V19h18V9.52L10.01 1Z",
    fill: "currentColor"
  }));
}

export { SvgHomeNavIcon as default };
